import { Component, EventEmitter, Input, Output, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Newest } from "../../../../model/filters/newest";
import { Router } from "@angular/router";

@Component({
  selector: "by-new-west-form",
  templateUrl: "./by-new-west-form.component.html",
  styleUrls: ["./by-new-west-form.component.css"],
})
export class ByNewWestFormComponent implements OnInit {
  @Input() filter: Newest = new Newest();
  @Output() applyFilter = new EventEmitter<Newest>();

  newestForm: FormGroup;
 

  constructor(private fb: FormBuilder, private router: Router) {}

  ngOnInit(): void {
    this.initializeForm();
  }

  private initializeForm(): void {
    this.newestForm = this.fb.group({
      top: [this.filter.top, [Validators.required, Validators.min(1)]],
    });
  }

  apply(): void {
    if (this.newestForm.valid) {
      const topValue = this.newestForm.get("top")?.value;
      const updatedFilter: Newest = new Newest(topValue);

      this.applyFilter.emit(updatedFilter);
  
    }
  }
}
